import { render, staticRenderFns } from "./CaptainProfile.vue?vue&type=template&id=78688614&scoped=true"
import script from "./CaptainProfile.vue?vue&type=script&lang=js"
export * from "./CaptainProfile.vue?vue&type=script&lang=js"
import style0 from "./CaptainProfile.vue?vue&type=style&index=0&id=78688614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78688614",
  null
  
)

export default component.exports